import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { X, Zap, Check } from 'lucide-react';
import { FREE_DAILY_SEARCHES } from '../config/quotas';
import { PREMIUM_PRICE_LABEL } from '../config/pricing';

const QuotaLimitModal = ({ onClose, onUpgrade }) => {
  return (
    <div className="fixed inset-0 bg-black/50 dark:bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
      <Card className="max-w-md w-full p-8 bg-white dark:bg-gray-900 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
            <Zap className="w-8 h-8 text-amber-600 dark:text-amber-400" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
            Limite gratuite atteinte
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Vous avez utilisé vos <strong>{FREE_DAILY_SEARCHES} recherches quotidiennes</strong>
          </p>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-950/30 dark:to-emerald-950/30 border-2 border-green-200 dark:border-green-800 rounded-xl p-6 mb-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">Remadia Premium</h3>
            <div className="text-right">
              <div className="text-3xl font-bold text-green-600 dark:text-green-400">{PREMIUM_PRICE_LABEL}</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">/mois</div>
            </div>
          </div>

          <ul className="space-y-2 mb-4">
            <li className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
              <Check className="w-5 h-5 text-green-600 dark:text-green-400" />
              Recherches illimitées
            </li>
            <li className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
              <Check className="w-5 h-5 text-green-600 dark:text-green-400" />
              Accès prioritaire
            </li>
            <li className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
              <Check className="w-5 h-5 text-green-600 dark:text-green-400" />
              Nouvelles fonctionnalités en avant-première
            </li>
          </ul>

          <Button
            onClick={onUpgrade}
            className="w-full bg-green-600 hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-800 text-white"
          >
            Passer à Premium
          </Button>
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            Ou revenez demain pour {FREE_DAILY_SEARCHES} nouvelles recherches gratuites
          </p>
          <Button
            onClick={onClose}
            variant="outline"
            className="dark:border-gray-700 dark:text-gray-300"
          >
            Fermer
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default QuotaLimitModal;
